type Props = {
  total: number;
  current: number;
  className?: string;
};

/** Dots — onboarding wizard progress indicator. */
export function Dots({ total, current, className }: Props) {
  return (
    <div className={`flex gap-1.5 ${className ?? ""}`}>
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className="h-[3px] flex-1 rounded-[2px] transition-colors"
          style={{
            background:
              i < current
                ? "var(--color-acid)"
                : i === current
                  ? "var(--color-text-muted)"
                  : "var(--color-border)",
          }}
        />
      ))}
    </div>
  );
}
